import { createElementBlock as o, openBlock as l, createElementVNode as e } from "vue";
import r from "./index289.js";
const n = {}, a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(c, t, p, d, i, f) {
  return l(), o("svg", a, t[0] || (t[0] = [
    e("path", {
      fill: "currentColor",
      d: "m12 2.25-.276.004C6.449 2.407 2.25 6.722 2.25 12l.004.276C2.407 17.551 6.722 21.75 12 21.75l.276-.004c5.275-.153 9.474-4.468 9.474-9.746l-.004-.276C21.593 6.449 17.278 2.25 12 2.25Z"
    }, null, -1),
    e("path", {
      fill: "#FFF",
      d: "M12 7.25a.75.75 0 0 1 .743.648L12.75 8v3.25H16a.75.75 0 0 1 .102 1.493L16 12.75h-3.25V16a.75.75 0 0 1-1.493.102L11.25 16v-3.25H8a.75.75 0 0 1-.102-1.493L8 11.25h3.25V8a.75.75 0 0 1 .75-.75Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ r(n, [["render", s]]);
export {
  u as default
};
